function getData(x, y) {
    let data = new Array(x.length);
    for (let i = 0; i < x.length; i++) {
        data[i] = { x: x[i], y: y[i] };
    }
    return data;
}
/**
 * Generate a jsgraph chart format from an array of Analysis
 */
export function getReactPlotJSON(analyses, query, options = {}) {
    const { xAxis: xAxisOptions = {}, yAxis: yAxisOptions = { labelSpace: 40 }, series: seriesOptions = { displayMarker: true }, dimentions = { width: 550, height: 500 }, } = options;
    let series = [];
    let meta = [];
    let xAxis = null;
    let yAxis = null;
    for (const analysis of analyses) {
        const spectra = analysis.getXYSpectrum(query);
        if (!spectra)
            continue;
        if (spectra.meta) {
            meta.push(spectra.meta);
        }
        xAxis = {
            id: 'x',
            label: spectra.variables.x.label,
            ...xAxisOptions,
            position: 'bottom',
        };
        yAxis = {
            id: 'y',
            label: spectra.variables.y.label,
            ...yAxisOptions,
            position: 'left',
        };
        const data = getData(spectra.variables.x.data, spectra.variables.y.data);
        const serie = {
            type: 'line',
            label: spectra.title,
            data,
            ...seriesOptions,
        };
        series.push(serie);
    }
    if (xAxis === null || yAxis === null) {
        throw new Error('The axes were not defined');
    }
    return {
        series,
        axes: [xAxis, yAxis],
        dimentions,
        meta,
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0UmVhY3RQbG90SlNPTi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZWFjdFBsb3QvZ2V0UmVhY3RQbG90SlNPTi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUEwQkEsU0FBUyxPQUFPLENBQUMsQ0FBYSxFQUFFLENBQWE7SUFDM0MsSUFBSSxJQUFJLEdBQWEsSUFBSSxLQUFLLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQ3pDLEtBQUssSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxDQUFDLENBQUMsTUFBTSxFQUFFLENBQUMsRUFBRSxFQUFFO1FBQ2pDLElBQUksQ0FBQyxDQUFDLENBQUMsR0FBRyxFQUFFLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDO0tBQ2hDO0lBQ0QsT0FBTyxJQUFJLENBQUM7QUFDZCxDQUFDO0FBRUQ7O0dBRUc7QUFDSCxNQUFNLFVBQVUsZ0JBQWdCLENBQzlCLFFBQW9CLEVBQ3BCLEtBQW1CLEVBQ25CLFVBQTRCLEVBQUU7SUFFOUIsTUFBTSxFQUNKLEtBQUssRUFBRSxZQUFZLEdBQUcsRUFBRSxFQUN4QixLQUFLLEVBQUUsWUFBWSxHQUFHLEVBQUUsVUFBVSxFQUFFLEVBQUUsRUFBRSxFQUN4QyxNQUFNLEVBQUUsYUFBYSxHQUFHLEVBQUUsYUFBYSxFQUFFLElBQUksRUFBRSxFQUMvQyxVQUFVLEdBQUcsRUFBRSxLQUFLLEVBQUUsR0FBRyxFQUFFLE1BQU0sRUFBRSxHQUFHLEVBQUUsR0FDekMsR0FBRyxPQUFPLENBQUM7SUFDWixJQUFJLE1BQU0sR0FBRyxFQUFFLENBQUM7SUFDaEIsSUFBSSxJQUFJLEdBQThCLEVBQUUsQ0FBQztJQUN6QyxJQUFJLEtBQUssR0FBcUIsSUFBSSxDQUFDO0lBQ25DLElBQUksS0FBSyxHQUFxQixJQUFJLENBQUM7SUFFbkMsS0FBSyxNQUFNLFFBQVEsSUFBSSxRQUFRLEVBQUU7UUFDL0IsTUFBTSxPQUFPLEdBQUcsUUFBUSxDQUFDLGFBQWEsQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUM5QyxJQUFJLENBQUMsT0FBTztZQUFFLFNBQVM7UUFFdkIsSUFBSSxPQUFPLENBQUMsSUFBSSxFQUFFO1lBQ2hCLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO1NBQ3pCO1FBRUQsS0FBSyxHQUFHO1lBQ04sRUFBRSxFQUFFLEdBQUc7WUFDUCxLQUFLLEVBQUUsT0FBTyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsS0FBSztZQUNoQyxHQUFHLFlBQVk7WUFDZixRQUFRLEVBQUUsUUFBUTtTQUNuQixDQUFDO1FBQ0YsS0FBSyxHQUFHO1lBQ04sRUFBRSxFQUFFLEdBQUc7WUFDUCxLQUFLLEVBQUUsT0FBTyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsS0FBSztZQUNoQyxHQUFHLFlBQVk7WUFDZixRQUFRLEVBQUUsTUFBTTtTQUNqQixDQUFDO1FBRUYsTUFBTSxJQUFJLEdBQUcsT0FBTyxDQUFDLE9BQU8sQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLElBQUksRUFBRSxPQUFPLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQztRQUN6RSxNQUFNLEtBQUssR0FBbUI7WUFDNUIsSUFBSSxFQUFFLE1BQU07WUFDWixLQUFLLEVBQUUsT0FBTyxDQUFDLEtBQUs7WUFDcEIsSUFBSTtZQUNKLEdBQUcsYUFBYTtTQUNqQixDQUFDO1FBQ0YsTUFBTSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQztLQUNwQjtJQUVELElBQUksS0FBSyxLQUFLLElBQUksSUFBSSxLQUFLLEtBQUssSUFBSSxFQUFFO1FBQ3BDLE1BQU0sSUFBSSxLQUFLLENBQUMsMkJBQTJCLENBQUMsQ0FBQztLQUM5QztJQUVELE9BQU87UUFDTCxNQUFNO1FBQ04sSUFBSSxFQUFFLENBQUMsS0FBSyxFQUFFLEtBQUssQ0FBQztRQUNwQixVQUFVO1FBQ1YsSUFBSTtLQUNMLENBQUM7QUFDSixDQUFDIn0=